<template>
  <button type="button"
    class="toggle"
    :class="{ on: isOn }"
    @click="isOn = !isOn"
    :title="isOn ? 'SIM' : 'NÃO'">
    <span class="dot"></span>
    <span class="lbl">{{ isOn ? 'SIM' : 'NÃO' }}</span>
  </button>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: { type: Number, default: 0 }
})
const emit = defineEmits(['update:modelValue'])

const isOn = computed({
  get: () => props.modelValue === 1,
  set: (v) => emit('update:modelValue', v ? 1 : 0)
})
</script>

<style scoped>
.toggle{
  display:flex; align-items:center; gap: 8px;
  border: 1px solid #e6e6e6; border-radius: 999px;
  padding: 6px 10px; background: #fafafa; cursor:pointer;
}
.toggle .dot{
  width: 10px; height: 10px; border-radius: 50%;
  background: #999;
}
.toggle.on{ background:#eaf2ff; border-color:#cfe0ff; }
.toggle.on .dot{ background:#1f6feb; }
.toggle .lbl{ font-size: 12px; font-weight: 700; }

.toggle:hover {
  color: #999;
}

</style>
